import { Component, output, input } from '@angular/core';

import { ApActionIconComponent, ApIconComponent } from '@ap/icon';

import { NavigationItem } from '../header.model';

@Component({
    selector: 'ap-search-icon',
    templateUrl: './search-icon.component.html',
    styleUrls: ['./search-icon.component.scss'],
    imports: [ApActionIconComponent, ApIconComponent]
})
export class ApSearchIconComponent {
    /**
     * Required - The search navigation item
     */
    public readonly searchNavigationItem = input.required<NavigationItem>();

    /**
     * emits if the search button is clicked
     */
    public readonly searchClicked = output<NavigationItem>();
}
